import { CaseModal, createProjectCase, updateProjectCase } from '@/services/project/cases.service'
import { useRequest } from 'ahooks'
import { Form, Input, Modal, ModalProps } from 'antd'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

interface AddEditCaseModalProps extends ModalProps {
  projectId: number
  onSuccess: () => void
  projectCase?: CaseModal
}

function AddEditCaseModal(props: AddEditCaseModalProps) {
  const { projectId, projectCase, onSuccess, onCancel } = props
  const [visible, setVisible] = useState(true)
  const [form] = Form.useForm()
  const { loading, run } = useRequest(
    (values) => {
      if (projectCase) {
        return updateProjectCase(values, {pId: projectId, id: projectCase.id})
      } else {
        return createProjectCase(values, {pId: projectId})
      }
    },
    {
      manual: true,
      onSuccess: () => {
        handleCancel()
        onSuccess()
      }
    }
  )

  const handleCancel = (e?) => {
    setVisible(false)
    onCancel?.(e)
  }

  useEffect(() => {
    if (projectCase) {
      form.setFieldsValue(projectCase)
    }
  }, [])

  return (
    <Modal
      {...props}
      width={600}
      maskClosable={false}
      open={visible}
      onCancel={handleCancel}
      confirmLoading={loading}
      onOk={() => form.submit()}
    >
      <h3>Create Case</h3>
      <Form
        form={form}
        className='mt-3'
        onFinish={(values) => {
          run(values)
        }}
      >
        <Form.Item label='Number' name='number' rules={[{ required: true, message: 'Please enter case number' }]}>
          <Input type='text' />
        </Form.Item>
        <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter case name' }]}>
          <Input type='text' />
        </Form.Item>
      </Form>
    </Modal>
  )
}

AddEditCaseModal.show = (props: AddEditCaseModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <AddEditCaseModal
      {...props}
      onCancel={(e) => {
        props.onCancel?.(e)
        clean()
      }}
    />,
    div
  )
}

export default AddEditCaseModal
